import { createAPIRequestReducer } from "../api"
import ActionTypes from "../../enums/ActionTypes"

export default createAPIRequestReducer(ActionTypes.PLANNING_OBJECTS_ORDER_POSITION_DETAILS_LOAD)
